import React from 'react';
import { Alert, Link } from '@amzn/awsui-components-react';
import { LockInfo } from 'src/models/common/LockInfo';
import { isLockedByOther } from './editLockUtils';
import { LOCK_SOURCE } from './constants';

export interface LockBannerProps {
    lockInfo?: LockInfo | null;
    currentUser?: string;
    entityLabel?: string;
}

export function LockBanner({ lockInfo, currentUser, entityLabel = 'entity' }: LockBannerProps) {
    if (!isLockedByOther(lockInfo, currentUser)) {
        return null;
    }

    const lockedByEntityType = lockInfo?.lockedByEntityType;
    const lockedBy = lockInfo?.lockedBy || 'another user';

    switch (lockedByEntityType) {
        case LOCK_SOURCE.TPA_WORKSHEET_TEMPLATE:
            return (
                <Alert type="warning" header="Locked by template">
                    This worksheet's template is currently being edited.
                    You cannot make changes until the template edit is completed.
                </Alert>
            );

        case LOCK_SOURCE.TPA_WORKSHEET: {
            const worksheetLink = `/calculations/tpAllocation/linked/${btoa(lockedBy)}`;
            return (
                <Alert type="warning" header="Template locked">
                    This template is locked because <Link href={worksheetLink}>one of its linked worksheets</Link> is being edited.
                </Alert>
            );
        }

        default:
            return (
                <Alert type="warning" header={`${entityLabel.charAt(0).toUpperCase() + entityLabel.slice(1)} locked`}>
                    This {entityLabel} is currently being edited by <strong>{lockedBy}</strong>.
                </Alert>
            );
    }
}

export default LockBanner;
